import { useCallback } from 'react';

import { useNavigationContext } from '../context';
import { type NavigationItem } from '../types/Sidebar.types';
import { getAppFromPath } from '../utilities/getAppFromPath';

/**
 * Hook to handle client-side routing for sidebar links
 * Returns a function that provides URL and onClick handler based on the current app context
 */
export const useWithClientRouting = (): ((path: string) => NavigationItem) => {
  const { currentPathname, navigate } = useNavigationContext();
  return useCallback(
    (path: string) => {
      const inClientRoutableApp: boolean =
        getAppFromPath(currentPathname) === getAppFromPath(path);

      return {
        url: path,
        onClick: inClientRoutableApp ? () => navigate.push(path) : undefined,
      };
    },
    [currentPathname, navigate],
  );
};
